module.exports = __webpack_public_path__ + "img/C73401.296b44e3.png";